// privatokonomi-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'pkn.ctl.avgOne': 'Promedio de entradas y salidas del último {count} mes',
  'pkn.ctl.avgMany': 'Promedio de entradas y salidas de los últimos {count} meses',
  'pkn.ctl.missingIncomeData': 'Faltan datos de ingresos y gastos',
  'pkn.ctl.title': 'Control financiero',
  'pkn.ctl.sub': 'Colchón, margen mensual y calidad de los datos',
  'pkn.ctl.adjustBuffer': 'Ajustar colchón',
  'pkn.ctl.missingSpendData': 'Faltan datos de gastos',
  'pkn.ctl.bufferMonths': '{count} meses de gasto normal',
  'pkn.ctl.bufferTarget': 'Objetivo del colchón',
  'pkn.ctl.gapRemaining': 'Faltan {amount}',
  'pkn.ctl.targetCovered': 'El objetivo está cubierto',
  'pkn.ctl.leftPerMonth': 'Sobrante al mes',
  'pkn.ctl.missingData': 'Faltan datos',
  'pkn.ctl.coverageTitle': 'Cobertura de datos y trazabilidad',
  'pkn.ctl.lastUpdated': 'Última actualización: {date}',
  'pkn.ctl.coverageCounts': '{accounts} cuentas · {transactions} transacciones · {uncategorized} sin categorizar',
  'pkn.ctl.missingMonths': 'faltan {months}',
  'pkn.ctl.unlinkedImports': '{count} importaciones sin cuenta',
  'pkn.ctl.duplicateImports': '{count} posibles importaciones duplicadas',
  'pkn.ctl.adjustTarget': 'Ajustar objetivo del colchón',
  'pkn.ctl.autoHint': 'La sugerencia automática equivale a tres meses de gastos registrados.',
  'pkn.ctl.useAuto': 'Usar sugerencia automática',
  'pkn.ctl.allTx': 'Todas las transacciones',
  'pkn.ctl.allTxSub': 'Busca, filtra, exporta y abre una categoría para corregir asientos',
  'pkn.ctl.exportCsv': 'Exportar CSV',
  'pkn.ctl.searchTx': 'Buscar transacciones',
  'pkn.ctl.type': 'Tipo',
  'pkn.ctl.allTypes': 'Todos los tipos',
  'pkn.ctl.expense': 'Gasto',
  'pkn.ctl.debtPayment': 'Pago de deuda',
  'pkn.ctl.transfer': 'Transferencia',
  'pkn.ctl.allCategories': 'Todas las categorías',
  'pkn.ctl.noMatch': 'Ninguna transacción coincide con los filtros.',
  'pkn.ctl.transaction': 'Transacción',
  'pkn.ctl.other': 'Otros',
  'pkn.eie.type.cash': 'Efectivo y cuenta corriente',
  'pkn.eie.type.savings': 'Colchón y cuenta de ahorro',
  'pkn.eie.type.fund': 'Fondos',
  'pkn.eie.type.shares': 'Acciones',
  'pkn.eie.type.other-investment': 'Otras inversiones',
  'pkn.eie.type.property': 'Inmuebles',
  'pkn.eie.type.vehicle': 'Vehículo',
  'pkn.eie.type.collectible': 'Objetos de colección',
  'pkn.eie.type.other': 'Otros',
  'pkn.eie.icon.home': 'Inmueble',
  'pkn.eie.icon.car': 'Vehículo',
  'pkn.eie.icon.building': 'Propiedad vacacional',
  'pkn.eie.icon.wallet': 'Ahorro',
  'pkn.eie.icon.trendUp': 'Fondos / acciones',
  'pkn.eie.icon.sparkle': 'Objetos de valor',
  'pkn.eie.health.riskLabel': 'Riesgo alto',
  'pkn.eie.health.riskNote': 'Se espera que el valor caiga rápidamente',
  'pkn.eie.health.pressLabel': 'Bajo presión',
  'pkn.eie.health.pressNote': 'Crece más despacio que la inflación',
  'pkn.eie.health.strongLabel': 'Inversión sólida',
  'pkn.eie.health.strongNote': 'Buen rendimiento a lo largo del tiempo',
  'pkn.eie.health.stableLabel': 'Estable',
  'pkn.eie.health.stableNote': 'Valor constante y predecible',
  'pkn.eie.factor.diversification': 'Diversificación',
  'pkn.eie.factor.diversificationNote': 'Reparto entre distintos tipos de activos',
  'pkn.eie.factor.liquidity': 'Liquidez',
  'pkn.eie.factor.liquidityNote': 'Parte que puedes convertir rápidamente en efectivo',
  'pkn.eie.factor.risk': 'Nivel de riesgo',
  'pkn.eie.factor.riskNote': 'Cuánto está en activos que se deprecian rápidamente',
  'pkn.eie.factor.leverage': 'Nivel de endeudamiento',
  'pkn.eie.factor.leverageNote': 'Patrimonio neto en relación con la deuda',
  'pkn.eie.expectedPerMonth': 'previsto al mes',
  'pkn.eie.expectedToChange': 'debería variar',
  'pkn.eie.perYearWithValue': 'al año. Con un valor de {value}, equivale a unos {amount} {kind} cada mes.',
  'pkn.eie.valueFall': 'de pérdida de valor',
  'pkn.eie.valueGrowth': 'de aumento de valor',
  'pkn.eie.projectionNote': 'La proyección de abajo usa tu propia expectativa de variación anual del valor. Plumme todavía no obtiene datos de mercado de viviendas, coches usados ni fondos; cuando esté disponible, actualizaré la estimación automáticamente.',
  'pkn.eie.fillNameValue': 'Introduce el nombre y el valor',
  'pkn.eie.editAsset': 'Editar activo',
  'pkn.eie.addAsset': 'Añadir activo',
  'pkn.eie.fieldName': 'Nombre del activo',
  'pkn.eie.phName': 'P. ej. Casa unifamiliar',
  'pkn.eie.fieldDetail': 'Descripción',
  'pkn.eie.phDetail': 'P. ej. dirección, año del modelo o proveedor',
  'pkn.eie.fieldValue': 'Valor de venta/mercado hoy (kr)',
  'pkn.eie.fieldTaxValue': 'Valor patrimonial fiscal (kr)',
  'pkn.eie.fieldGrowth': 'Variación anual esperada del valor (%)',
  'pkn.eie.phGrowth': 'p. ej. 3,5 o −12',
  'pkn.eie.assetType': 'Tipo de activo',
  'pkn.eie.pickColor': 'Elegir el color {color}',
  'pkn.eie.taxBasis': 'Valor fiscal {amount}',
  'pkn.eie.perYearSuffix': '/año',
  'pkn.eie.notRegistered': 'Sin registrar',
  'pkn.eie.liquidSub': 'Banco/efectivo {cash} · inversiones {investments}',
  'pkn.eie.liquidNote': 'El patrimonio líquido es el dinero en cuentas y los fondos/acciones que normalmente se pueden vender. La evaluación del colchón solo usa banco y efectivo, porque las inversiones pueden variar de valor.',
  'pkn.eie.verdict.solid': 'Patrimonio sólido y bien equilibrado',
  'pkn.eie.verdict.healthy': 'Patrimonio saludable con margen de ajuste',
  'pkn.eie.verdict.rebalance': 'Conviene equilibrar mejor tu patrimonio',
  'pkn.eie.watchMostPrefix': 'Lo que sigo más de cerca es',
  'pkn.eie.mostRoom': 'aquí hay más margen para reforzar tu patrimonio.',
  'pkn.eie.fineButBetter': 'que está bien, pero podría mejorar aún más.',
  'pkn.eie.perMonth': 'al mes',
  'pkn.eie.monthlyForecastNote': 'al mes. Cuando se conecten los datos de mercado, actualizaré la estimación automáticamente según los mercados de vivienda, coches usados y fondos.',
  'pkn.eie.valueToday': 'El valor actual es {value}.',
  'pkn.eie.watchClear': 'Ninguno de tus activos requiere seguimiento adicional por ahora. Todo parece saludable y equilibrado según las hipótesis que has introducido.',
  'pkn.eie.fallWarn': 'Se espera que el valor caiga {pct} al año.',
  'pkn.eie.slowWarn': 'Crece más despacio que la inflación ({pct} al año).',
  'pkn.eie.monthlyEquiv': 'Equivale a {amount} al mes.',
  'pkn.eie.empty': 'Todavía no hay activos registrados. Pulsa «Añadir activo» para registrar casa, coche, barco, cabaña, arte, ahorros, fondos y más.',
  'pkn.fam.fair.even': 'Reparto equilibrado',
  'pkn.fam.fair.slightly': 'Algo desequilibrado',
  'pkn.fam.fair.uneven': 'Desequilibrado',
  'pkn.fam.needTwo': 'Introduce al menos dos personas con ingresos y parte de los gastos comunes, y compararé el reparto con la proporción de ingresos.',
  'pkn.fam.perMonthShort': '/ mes',
  'pkn.fam.ofSharedCosts': '{pct} % de los gastos comunes',
  'pkn.fam.ofIncome': '{pct} % de los ingresos',
  'pkn.fam.evenSuffix': 'en gastos comunes cada mes, y cada uno de ustedes cubre aproximadamente la parte que corresponde a sus ingresos.',
  'pkn.fam.uneven': 'cubre el {costShare} % de los gastos comunes, pero aporta el {incomeShare} % de los ingresos. Un reparto según los ingresos daría {amount} al mes, es decir, {diff} {direction} que ahora. Lo que sea correcto lo deciden ustedes; esto es solo el cálculo.',
  'pkn.fam.less': 'menos',
  'pkn.fam.more': 'más',
  'pkn.fam.idea.bufferTitle': 'Construyan un fondo de reserva común',
  'pkn.fam.idea.bufferText': 'Después de los gastos comunes, el hogar tiene {left} libres cada mes. Si apartan el 10 % de esa cantidad ({monthly} al mes), tendrán {yearly} de reserva dentro de un año.',
  'pkn.fam.metricPerMonth': '{amount}/mes',
  'pkn.fam.idea.keyTitle': 'Acuerden la clave de reparto',
  'pkn.fam.idea.keyText': 'El reparto de los gastos comunes se desvía más de 15 puntos porcentuales de la proporción de ingresos. Muchos eligen un reparto igualitario o según los ingresos; lo importante es que lo hayan elegido de forma consciente.',
  'pkn.fam.metricDeviation': '{pp} pp de desviación',
  'pkn.fam.idea.reviewTitle': 'Revisen juntos los gastos comunes',
  'pkn.fam.idea.reviewText': 'Pagan {monthly} en gastos comunes cada mes, es decir, {yearly} al año. Dediquen una tarde a revisar juntos las suscripciones, los seguros y el contrato de electricidad; ahí es donde la mayoría encuentra más ahorro.',
  'pkn.fam.metricPerYear': '{amount}/año',
  'pkn.fam.ideasEmpty': 'Cuando hayan introducido los ingresos y los gastos comunes, les propondré medidas concretas que pueden tomar juntos.',
  'pkn.fam.editPerson': 'Editar persona',
  'pkn.fam.addPerson': 'Añadir persona',
  'pkn.fam.goToMyPage': 'Ir a Mi página',
  'pkn.fam.devMode': 'Modo de desarrollo: todavía no estás conectado con una pareja. Los datos que registres aquí permanecen en tu propio cliente de Finanzas personales. Vincula dos cuentas separadas en Mi página para compartir el perfil Familia.',
  'pkn.fam.askSuperPlumma': 'Preguntar a SuperPlumma',
  'pkn.fam.connectedEmpty': 'Ya están vinculados. Introduzcan la información que quieran compartir para comparar la proporción de ingresos y la parte de los gastos comunes.',
  'pkn.fam.subShared': 'Compartido entre las cuentas de Finanzas personales vinculadas',
  'pkn.fam.subLocal': 'Vista local de desarrollo · no compartida',
  'pkn.fam.cardSub': 'gastos comunes / mes · ingresos {income}',
  'pkn.fam.cardShares': '{income} % de los ingresos · {costs} % de los gastos comunes',
  'pkn.fam.householdSuffix': 'en gastos comunes al mes. Compara la proporción de gastos con la proporción de ingresos para valorar el reparto.',
  'pkn.for.tone.over': 'Por encima del presupuesto',
  'pkn.for.tone.near': 'Cerca del límite',
  'pkn.for.tone.within': 'Dentro del presupuesto',
  'pkn.for.noImportedMonth': 'No hay transacciones importadas este mes',
  'pkn.for.plannedIncome': 'Ingresos previstos',
  'pkn.for.incomeHint': 'Usa el salario bruto y el porcentaje de impuestos cuando conozcas el salario acordado. El neto es lo que esperas recibir en tu cuenta.',
  'pkn.for.grossPerMonth': 'Bruto al mes',
  'pkn.for.netToAccount': 'Neto ingresado en la cuenta',
  'pkn.for.limitHint': 'El límite se fija por categoría principal. Tus propias categorías de abajo se suman además.',
  'pkn.for.used': 'usado {amount}',
  'pkn.for.showAsGroup': 'Mostrar como categoría principal propia en «Adónde va el dinero»',
  'pkn.for.budgetUpdated': 'El presupuesto se ha actualizado',
  'pkn.for.gross': '{amount} brutos',
  'pkn.for.taxPct': '{pct} % de impuestos',
  'pkn.for.netPerMonth': 'Neto al mes',
  'pkn.for.budgetUses': 'el presupuesto usa el {pct} %',
  'pkn.for.noBudgets': 'Todavía no has fijado presupuesto para ninguna categoría. Pulsa «Ajustar presupuesto» para fijar un límite mensual; así lo vigilaré y te avisaré cuando una categoría se acerque.',
  'pkn.for.budgetedInPeriod': 'presupuestado en el periodo',
  'pkn.for.leftInPeriod': 'Quedan {amount} en el periodo',
  'pkn.for.overBudget': '{amount} por encima del presupuesto',
  'pkn.for.allWithin': 'Todas las categorías dentro del presupuesto',
  'pkn.for.overLimitOne': '{count} categoría por encima del límite',
  'pkn.for.overLimitMany': '{count} categorías por encima del límite',
  'pkn.for.pctUsed': '{pct} % usado',
  'pkn.for.diffLeft': 'Quedan {amount}',
  'pkn.for.diffOver': '{amount} de más',
  'pkn.for.mainCategories': 'Categorías principales',
  'pkn.for.allCategories': 'Todas las categorías',
  'pkn.for.noSpendInPeriod': 'No hay gastos registrados en {period}. Elige otro periodo o sube el extracto de este mes en Importar.',
  'pkn.for.noSpendData': 'Todavía no hay datos de gastos. Sube un extracto bancario en Importar y leeré las transacciones y las categorizaré automáticamente.',
  'pkn.for.highlight': 'Resaltar {name} en el gráfico',
  'pkn.for.hideCats': 'Ocultar las categorías de {name}',
  'pkn.for.showCats': 'Mostrar las categorías de {name}',
  'pkn.for.seeTx': 'Ver las transacciones de {name}',
  'pkn.for.ofGroupSuffix': '% del grupo',
  'pkn.for.biggest': 'La {kind} más grande es',
  'pkn.for.kindCost': 'categoría de gasto',
  'pkn.for.kindMain': 'categoría principal',
  'pkn.for.biggestSuffix': 'con {amount}, el {pct} % del gasto del periodo.',
  'pkn.for.noRecurring': 'Todavía no he encontrado cargos recurrentes de suscripciones. Cuando se hayan leído más meses de extractos, listaré los cargos fijos con su coste anual calculado. Tú decides si el servicio sigue siendo útil.',
  'pkn.for.recurringTotal': 'Los cargos recurrentes del periodo seleccionado suman aproximadamente {amount} al año.',
  'pkn.for.annualNote': 'Este es un coste anual, no un ahorro garantizado. Revisa cada cargo antes de cambiar nada.',
  'pkn.for.confidence': 'Confianza {pct} %',
  'pkn.for.showTx': 'Mostrar transacciones',
  'pkn.for.yesSubscription': 'Sí, es una suscripción',
  'pkn.for.iUseIt': 'Lo uso',
  'pkn.for.iWantToCancel': 'Quiero cancelarlo',
  'pkn.for.remindLater': 'Recordármelo más tarde',
  'pkn.fut.notSet': 'sin definir',
  'pkn.fut.notBeforeRetirement': 'no antes de la jubilación',
  'pkn.fut.status.reached': 'Alcanzado',
  'pkn.fut.status.planned': 'Planificado',
  'pkn.fut.status.noSaving': 'Falta el importe de ahorro',
  'pkn.fut.factor.progress': 'Avance hacia los objetivos',
  'pkn.fut.factor.progressNote': 'Se ha ahorrado el {pct} % del importe total de los objetivos',
  'pkn.fut.factor.onPlan': 'Objetivos según lo previsto',
  'pkn.fut.factor.onPlanNote': '{count} de {total} objetivos van bien encaminados',
  'pkn.fut.factor.autoBalance': 'Saldo automático',
  'pkn.fut.factor.autoBalanceNote': '{count} de {total} objetivos están vinculados a una cuenta',
  'pkn.fut.life.goalReached': '{name} alcanzado',
  'pkn.fut.life.netWorthPasses': 'El patrimonio neto supera {amount}',
  'pkn.fut.life.retireAge': 'Edad de jubilación: {age} años',
  'pkn.fut.impact.netWorth5': 'Patrimonio neto en 5 años',
  'pkn.fut.impact.retireAge': 'Edad de jubilación',
  'pkn.fut.ageYears': '{age} años',
  'pkn.fut.impact.savingToGoals': 'Ahorro para objetivos',
  'pkn.fut.perMonth': '{amount}/mes',
  'pkn.fut.xOfY': '{count} de {total}',
  'pkn.fut.impact.debt': 'Deuda',
  'pkn.fut.unchanged': 'Sin cambios',
  'pkn.fut.goalSaved': 'El objetivo se ha guardado',
  'pkn.fut.eventSaved': 'El evento vital se ha guardado',
  'pkn.fut.enterAssumptions': 'Introduce tus propias hipótesis antes de que Plumme haga proyecciones.',
  'pkn.fut.noForecast': 'No mostramos una proyección personal basada en una edad, una rentabilidad o una edad de jubilación por defecto. Crea primero el plan con tus propias cifras.',
  'pkn.fut.createPlan': 'Crear plan de futuro',
  'pkn.fut.horizon1': '1 año',
  'pkn.fut.horizon5': '5 años',
  'pkn.fut.horizon10': '10 años',
  'pkn.fut.horizonRetirement': 'Jubilación',
  'pkn.fut.reaches': 'se alcanza',
  'pkn.fut.expectedAtRetirement': 'Patrimonio esperado al jubilarte ({age} años):',
  'pkn.fut.forMonths': 'durante {count} meses',
  'pkn.fut.permanent': 'permanente',
  'pkn.fut.oneOff': '{amount} una vez',
  'pkn.fut.incoming': '{amount} de entrada',
  'pkn.fut.switchOn': 'Activar',
  'pkn.fut.switchOff': 'Desactivar',
  'pkn.fut.eventRemoved': 'El evento vital se ha eliminado',
  'pkn.fut.goalsOnTrackSuffix': 'objetivos en marcha · {pct} % de avance total',
  'pkn.fut.first': 'primero',
  'pkn.fut.priorityBody': 'Este objetivo es el que más seguimiento necesita en el plan. Faltan {amount}.',
  'pkn.fut.targetDate': 'Con el plan actual, la fecha objetivo calculada es {date}.',
  'pkn.fut.cannotCalcEnd': 'No se puede calcular la fecha final con el importe de ahorro actual',
  'pkn.fut.noGoals': 'Todavía no tienes objetivos. Añade el primero (colchón, entrada de una vivienda, vacaciones u otro) y calcularé cuándo lo alcanzarás y qué te lleva allí más rápido.',
  'pkn.fut.planStatus': 'Estado del plan',
  'pkn.fut.action1': 'Configura una transferencia fija el día de cobro',
  'pkn.fut.action2': 'Aumenta un poco el ahorro mensual',
  'pkn.fut.action3': 'Traslada aquí una cantidad puntual',
  'pkn.fut.reachesGoal': '{name} alcanza el objetivo',
  'pkn.fut.amountLeft': 'Faltan {amount}',
  'pkn.fut.courseA': 'Este es el rumbo que llevan tus finanzas con el plan que has introducido',
  'pkn.fut.courseB': 'Cada pequeño ajuste (algo más de ahorro, una refinanciación, una suscripción cancelada) acerca toda la línea temporal.',
  'pkn.fut.goalDeleted': 'El objetivo se ha eliminado',
  'pkn.fut.deleteGoalBody': 'El avance de {amount} desaparece del resumen y el objetivo se elimina de tu proyección y de tu plan de vida.',
  'pkn.fut.familyIntro': 'Finanzas familiares muestra quién del hogar paga qué, cómo están situados unos respecto a otros y qué tan justo es el reparto en relación con los ingresos. Para calcularlo necesito los miembros del hogar y la titularidad de las transacciones; eso se conectará en un paso posterior.',
  'pkn.fut.noMembers': 'Todavía no hay miembros del hogar registrados. Cuando el hogar esté configurado y las transacciones tengan titular, mostraré los gastos por persona, compararé el gasto categoría por categoría y calcularé qué tan justo es el reparto de los gastos comunes.',
  'pkn.fut.personalSpend': 'Gasto personal · tú frente a tu pareja',
  'pkn.fut.splitOne': 'al mes repartido entre {count} persona.',
  'pkn.fut.splitMany': 'al mes repartido entre {count} personas.',
  'pkn.gj.icon.card': 'Tarjeta/consumo',
  'pkn.gj.icon.home': 'Vivienda',
  'pkn.gj.icon.car': 'Coche',
  'pkn.gj.icon.bank': 'Banco/estudios',
  'pkn.gj.never': 'Nunca',
  'pkn.gj.monthsShort': '{count} meses',
  'pkn.gj.yearsShort': '{count} años',
  'pkn.gj.health.expensiveLabel': 'Deuda cara',
  'pkn.gj.health.expensiveNote': 'Interés superior al 12 %: revisa la refinanciación',
  'pkn.gj.health.highLabel': 'Interés alto',
  'pkn.gj.health.highNote': 'Interés superior al 8 %',
  'pkn.gj.health.lowLabel': 'Interés bajo',
  'pkn.gj.health.lowNote': 'Deuda asequible',
  'pkn.gj.health.okLabel': 'Interés razonable',
  'pkn.gj.health.okNote': 'Nivel de interés habitual',
  'pkn.gj.journey.paidOff': '{name} liquidado',
  'pkn.gj.journey.half': 'La mitad de {name} liquidada',
});
